module.exports = __webpack_public_path__ + "img/bespoke123_17.eb593cc6.jpg";